import axios, { AxiosResponse } from 'axios'; 
import { AccountLoginState, AccountRecoverPasswordState, CreateAccountRequest } from "../store/account/types";
import HttpMethod from './httpmethods';
import { ApiResponse } from './types';
import { AuthOTPState } from '../store/authOTP/types';
import { DependantRequest, PatientRequest } from '../store/medicalAppointment/types';

export async function postAccountLoginAPI(AccountLoginState: AccountLoginState): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/lead/saveLeadAccountPost', AccountLoginState);
}

export async function getleadPersonIdAPI(leadPersonId : string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/lead/' + leadPersonId, {});
}
export async function getTagAPI(slugName : string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/plandetail/tags/' + slugName, {});
}
// Payment Processors
export async function verifyTransactionPlaceToPayAPISOATOG(transactionId : string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/transaction/payment/verification/' + transactionId, {});
}
// End Payment Processors


export async function getCharginDataAPI(contractId : string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/contract/'+contractId+"/chargingdata", {});
}

export async function postAccountLoginUserAPI(accountLoginState: AccountLoginState): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/user/login' , accountLoginState);
}

export async function postCreateAccountAPI(createAccountRequest: CreateAccountRequest): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/user/register' , createAccountRequest);
}

export async function postRecoverAccountAPI(accountRecoverPassword: AccountRecoverPasswordState): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/user/recoverpassword' , accountRecoverPassword);
}

export async function postUpdateAccountAPI(accountUpdatePassword: AccountRecoverPasswordState): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/user/updatepassword' , accountUpdatePassword);
}

export async function postAuthOTPAPI(authOTP: AuthOTPState): Promise<ApiResponse> { 
   return await makeRequest(HttpMethod.POST, '/api/salud/user/otp', authOTP);
}

export async function postUserLoginAPI(authOTP: AuthOTPState): Promise<ApiResponse> {
     return await makeRequest(HttpMethod.POST, '/api/salud/user/login', authOTP);
}

export async function getUserDataAPI(): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/salud/clients' , {});
}

export async function putEditDependantAPI(dependant: DependantRequest): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/salud/dependant/'+ dependant.identification ,  dependant);
}

export async function postCreateDependantAPI(dependant: DependantRequest): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/salud/dependants', dependant);
}

export async function postUserAppointmentAPI(patient: PatientRequest): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/salud/appointments/preAppointment', patient);
}

export async function deleteUserDependantAPI(identification: string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.DELETE, '/api/salud/dependants/' + identification, {});
}

export async function putUnsubscribedAPI(token: string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/salud/unsubscribe/' + token, {});
}

export async function getDataKuskhi(idPlanDetail : string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/plandetail/' + idPlanDetail, {});
}

export async function getDataSales(identification : string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/lead/identification?identification=' + identification, {});
}

export async function getDataEPayco(idPlanDetail : string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/plandetail/' + idPlanDetail, {});
}

export async function getBankListPSE(): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/transaction/payment/epayco/bank', {});
}

export async function postValidateTokenPasswordResetAPI(accountRecoverPassword: AccountRecoverPasswordState): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/user/validatetoken', accountRecoverPassword);
}

export async function postPasswordResetAPI(accountRecoverPassword: AccountRecoverPasswordState): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/user/changepassword', accountRecoverPassword);
}

export async function getAcceptanceTokenAPI(): Promise<ApiResponse> {
   return await makeRequest(HttpMethod.GET, '/api/transaction/payment/wompi/token', {});
}

export async function getBankListPSEWompi(): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/transaction/payment/wompi/bank', {});
}

export async function makeRequest(method: string, url: string, object: Object): Promise<ApiResponse> {
    let response: AxiosResponse<any>;
    try {
        switch (method) {
            case HttpMethod.GET:
                response = await axios.get(url, object);
                break;
            case HttpMethod.POST:
                response = await axios.post(url, object);
                break;
            case HttpMethod.PUT:
                response = await axios.put(url, object);
                break;
            case HttpMethod.DELETE:
                response = await axios.delete(url, object);
                break;
            default:
                throw new Error('Invalid Method')
        }

        return {
            StatusCode: response.status,
            Response: response.data,
            Error: null
        }
    } catch (error) {
        return {
            StatusCode: error.response.status,
            Response: null,
            Error: error.response.data
        }
    }
}



